// !!!!!!!DEPRECATED!!!!!!!
// use useClerk hook instead

import { clerk } from '@utils/clerk';
import { ClerkActionType, ClerkCategoryType } from '@utils/clerk/types';

/*
 * This event need to send when user go to the detail page from feed of
 * products.
 */
export const generateGoToDetailEvent = (
  itemCount: string,
  productId: string,
  source = '',
) => {
  clerk.sendEvent(
    ClerkCategoryType.goToDetail,
    ClerkActionType.click,
    { itemCount, productId, source },
  );
};

